import { createSlice } from '@reduxjs/toolkit';
import { generateReduxKeys } from '../../utils';

const initialState = generateReduxKeys({
    customers: [],
    details: null,
    balance: null,
    specialPrices: [],
    suggestedPrices: [],
    purchaseItems: [],
    potentialPurchaseItems: [],
    notes: [],
    exclusionProducts: [],
});

const customersSlice = createSlice({
    name: 'customers',
    initialState,
    reducers: {
        setCustomers: (state, action) => {
            localStorage.setItem(`customers`, JSON.stringify(action.payload));
            state.customers = action.payload;
        },
        setCustomerDetails: (state, action) => {
            state.details = action.payload;
        },
        setCustomerBalance: (state, action) => {
            state.balance = action.payload;
        },
        setCustomerSpecialPrices: (state, action) => {
            state.specialPrices = action.payload;
        },
        setCustomerSuggestedPrices: (state, action) => {
            state.suggestedPrices = action.payload;
        },
        setCustomerPurchaseItems: (state, action) => {
            state.purchaseItems = action.payload;
        },
        setCustomerPotentialPurchaseItems: (state, action) => {
            state.potentialPurchaseItems = action.payload;
        },
        setCustomerNotes: (state, action) => {
            state.notes = action.payload;
        },
        setCustomerExclusionProducts: (state, action) => {
            state.exclusionProducts = action.payload;
        },
    },
});

export const {
    setCustomers,
    setCustomerDetails,
    setCustomerBalance,
    setCustomerSpecialPrices,
    setCustomerSuggestedPrices,
    setCustomerPurchaseItems,
    setCustomerPotentialPurchaseItems,
    setCustomerNotes,
    setCustomerExclusionProducts,
} = customersSlice.actions;
export default customersSlice.reducer;
